import styled from 'styled-components';
import { useEffect } from 'react';
import { Header } from '../components/main/Header';
import { CommonModal } from '../components/modal/CommonModal';
import { AgreePrivacy } from '../components/modal/AgreePrivacy';
import { EndDateModal } from '../components/modal/EndDateModal';
import { ImageUtils } from '../utils/ImageUtils';
import { TestBox } from '../components/TestBox';
import { closeWebview, isPc } from '../utils';
import { ENTRY_GROUP, useApiHook } from '../hook/useApiHook';
import { tabStore } from '../store/tabStore';
import { RewardInfo } from '../components/main/reward/RewardInfo';
import { ParticipationInfo } from '../components/main/participate/ParticipationInfo';
import { ProgressInfo } from '../components/main/progress/ProgressInfo';
import { MainEvent } from '../components/main/main-event/MainEvent';
import { InfoTab } from '../components/main/InfoTab';
import { MAIN_TAB_STATUS } from '../types/type';

export const MainPage = () => {
  const { getEventInfo } = useApiHook();
  const { mainTab } = tabStore();
  const isMobile = !isPc();

  useEffect(() => {
    if (isMobile) {
      getEventInfo(ENTRY_GROUP.MAIN);
      getEventInfo(ENTRY_GROUP.SIDE);
    }
  }, [isMobile, getEventInfo]);

  return (
    <Wrap>
      <Bg />
      <BgImgContainer />
      {/* <TestBox /> */}
      <HeaderContainer>
        {isMobile && <CloseButton src={ImageUtils.CloseIcon} onClick={closeWebview} />}
        <Header />
        <InfoTab />
      </HeaderContainer>
      <BottomContainer>
        <Inner>
          {mainTab === MAIN_TAB_STATUS.REWARD && <RewardInfo />}
          {mainTab === MAIN_TAB_STATUS.PARTICIPATE && <ParticipationInfo />}
          {mainTab === MAIN_TAB_STATUS.PROGRESS && <ProgressInfo />}
          {mainTab === MAIN_TAB_STATUS.MAIN_EVENT && <MainEvent />}
        </Inner>
      </BottomContainer>
      <CommonModal />
      <AgreePrivacy />
      <EndDateModal />
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
`;

const CloseButton = styled.img`
  width: 40px;
  height: 40px;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 1;
`;

const BottomContainer = styled.div`
  position: relative;
  background: #302e2d;
  display: flex;
  flex: 1;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
`;

const Bg = styled.div`
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  background: linear-gradient(
    164.47deg,
    #be2650 4.5%,
    #661128 24.9%,
    #3f0e1e 62.84%,
    #261605 100.33%
  );
  z-index: 0;
`;

const BgImgContainer = styled.div`
  position: fixed;
  width: 1920px;
  height: 587px;
  left: 0;
  top: 0;
  z-index: 0;
  left: 50%;
  transform: translateX(-50%);
  background-image: url(${ImageUtils.Bg});
`;
